import { render, staticRenderFns } from "./LessonChatMobile.vue?vue&type=template&id=e95a6510&scoped=true"
import script from "./LessonChatMobile.vue?vue&type=script&lang=js"
export * from "./LessonChatMobile.vue?vue&type=script&lang=js"
import style0 from "./LessonChatMobile.vue?vue&type=style&index=0&id=e95a6510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95a6510",
  null
  
)

export default component.exports